import ContactScreen from './components/ContactScreen'

export default {
  path: '/contactanos',
  name: 'Contact',
  component: ContactScreen
}



// WEBPACK FOOTER //
// ./src/app/screens/Contact/index.js